import { render, staticRenderFns } from "./contactWay.vue?vue&type=template&id=78c15272&scoped=true&"
import script from "./contactWay.vue?vue&type=script&lang=js&"
export * from "./contactWay.vue?vue&type=script&lang=js&"
import style0 from "./contactWay.vue?vue&type=style&index=0&id=78c15272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c15272",
  null
  
)

export default component.exports